import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { Messages } from '~src/codegen/Localize';
import { EditClusterNameField } from '~src/settings/dataconnect-settings/sections/dataConnectMultiCluster/EditClusterNameField';

export type PropsForAddDataConnectClusterDialog = ReactActionDialogBodyProps<
  AddDataConnectClusterDialogProps,
  AddDataConnectClusterDialogState
>;

export type AddDataConnectClusterDialogProps = Readonly<{
  existingClusterNames: string[];
}>

export type AddDataConnectClusterDialogState = Readonly<{
  clusterName: string;
  hasError: boolean;
}>

export function AddDataConnectClusterDialogBody(props: PropsForAddDataConnectClusterDialog) {
  const onClusterNameChange = (clusterName: string) => {
    props.updateDialogState({ clusterName });
  };
  const onHasErrorChange = (hasError: boolean) => {
    props.updateDialogState({ hasError });
  };

  return (
    <EditClusterNameField
      clusterName={props.dialogState.clusterName}
      onClusterNameChange={onClusterNameChange}
      hasError={props.dialogState.hasError}
      onHasErrorChange={onHasErrorChange}
      existingClusterNames={props.existingClusterNames}
      description={Messages.dataConnectSiteSettingsAddClusterDialogDescription()}
    />
  );
}
